import { render, staticRenderFns } from "./tambah-pertanyaan.vue?vue&type=template&id=3e4991df&"
import script from "./tambah-pertanyaan.vue?vue&type=script&lang=js&"
export * from "./tambah-pertanyaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports